import { Component, OnInit } from '@angular/core';
import { CMSPortalService } from '../../shared/service/cms-portal.service';
import { Enquete, Pergunta } from '../../shared/model/enquete.model';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { RadioOption } from '../../shared/radio/radio-option.model';
import { NotificationService } from '../../shared/messages/notification.service';
import { CheckboxOption } from '../../shared/checkbox/checkbox-option.model';
import { RespostaPergunta } from '../../shared/model/resposta-pergunta.model';
import { ResultadoFormulario } from '../../shared/model/resultado-formulario.model';

@Component({
  selector: 'app-conteudo-enquete',
  templateUrl: './enquete.component.html',
  styleUrls: ['./enquete.component.css']
})
export class EnqueteComponent implements OnInit {

  public enquete: Enquete;
  public resultado: ResultadoFormulario[];
  public mostrarResultado = false;
  enqueteForm: FormGroup;

  constructor(private service: CMSPortalService,
              private formBuilder: FormBuilder,
              private notificationService: NotificationService) { }

  ngOnInit() {
    this.getEnquete();
  }

  getEnquete() {
    this.service.getEnquete().subscribe(res => {
      this.enquete = res.conteudo;
      this.addEnqueteFormOption();
    });
  }

  addEnqueteFormOption() {
    const group = {};
    if (this.enquete) {
      for (const pergunta of this.enquete.perguntas) {
        if (pergunta.obrigatoria === 'S') {
          group[`pergunta-${pergunta.id}`] = ['', [Validators.required]];
        } else {
          group[`pergunta-${pergunta.id}`] = ['', []];
        }
      }
      this.enqueteForm = this.formBuilder.group(group);
    }
  }

  getFormControlName(pergunta: Pergunta): string {
    return `pergunta-${pergunta.id}`;
  }

  getOpcoes(pergunta: Pergunta): RadioOption[] {
    const options: RadioOption[] = [];
    for (const opcao of pergunta.opcoes) {
      options.push(new RadioOption(opcao.descricao, opcao.descricao));
    }
    return options;
  }

  getOpcoesCheck(pergunta: Pergunta): CheckboxOption[] {
    const options: CheckboxOption[] = [];
    for (const opcao of pergunta.opcoes) {
      options.push(new CheckboxOption(opcao.descricao, opcao.id, false));
    }
    return options;
  }

  responderEnquete(opcaoEscolhida) {
    for (const pergunta of this.enquete.perguntas) {
      const votos = opcaoEscolhida[`pergunta-${pergunta.id}`];
      if (votos.constructor.name === 'Array') {
        for (const voto of votos) {
          if (voto.selected) {
            const votoObj = new RespostaPergunta(voto.label, '', `${pergunta.id}`);
            this.service.salvarVotoEnquete(votoObj).subscribe(res => {
              this.atualizarResultado(`${pergunta.idSessao}`);
            });
          }
        }
      } else if (votos.constructor.name === 'String') {
        const votoObj = new RespostaPergunta(votos, '', `${pergunta.id}`);
        this.service.salvarVotoEnquete(votoObj).subscribe(res => {
          this.atualizarResultado(`${pergunta.idSessao}`);
        });
      } else { }
    }

    // this.notificationService.notify('Obrigado por responder a enquete.');
  }

  atualizarResultado(idSecao: string) {
    this.service.getResultadoEnquete(idSecao).subscribe(res => {
      this.mostrarResultado = true;
      this.resultado = res.conteudo;
    });
  }

}
